var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 607.51 217.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00868f;\n      }\n\n      .cls-2 {\n        fill: #f68f1e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.69,186.72l-1.15,8.6h-3.08l1.17-8.93-4.38-16.27h3.08l3.3,12.31,6.6-12.31h3.25l-8.8,16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.61,184.92c0-8.53,4.09-15.15,10.26-15.15,5.04,0,8.01,4.39,8.01,10.76,0,8.53-4.09,15.15-10.26,15.15-5.04,0-8.01-4.39-8.01-10.76Zm15.14-4.1c0-4.14-1.82-6.95-5.17-6.95-4.21,0-6.84,4.93-6.84,10.76,0,4.14,1.79,6.95,5.14,6.95,4.21,0,6.86-4.93,6.86-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.31,187.04c0-.86,.07-1.76,.19-2.7l1.89-14.22h3.11l-1.89,14.15c-.09,.83-.17,1.58-.17,2.23,0,3.42,1.34,5.08,3.71,5.08,2.65,0,4.26-2.2,4.95-7.34l1.87-14.11h3.06l-1.91,14.43c-.98,7.42-3.78,11.12-8.27,11.12-4.11,0-6.53-3.31-6.53-8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343.15,187.33l2.99,7.99h-3.3l-2.75-7.38h-4.16l-.96,7.38h-3.13l3.35-25.2h6.5c4.04,0,6.36,2.81,6.36,7.59s-1.82,8.32-4.9,9.61Zm1.77-9.18c0-2.74-1.29-4.07-3.56-4.07h-3.56l-1.34,10.01h3.71c3.01,0,4.76-2.05,4.76-5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.86,170.12h6.77c5.09,0,8.13,4.07,8.13,10.4,0,8.93-4.18,14.79-10.42,14.79h-7.82l3.35-25.2Zm4.57,21.24c4.5,0,7.2-4.5,7.2-10.55,0-4.14-1.79-6.73-5.33-6.73h-3.85l-2.3,17.28h4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M384.41,170.12h3.11l-3.35,25.2h-3.11l3.35-25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M403.63,182.43h2.94l-1.36,10.15c-1.67,1.98-3.92,3.1-6.24,3.1-5.02,0-8.13-4.36-8.13-10.76,0-8.53,4.09-15.15,10.4-15.15,3.06,0,5.33,1.48,6.72,4.14l-2.25,2.81c-1.1-2.02-2.58-2.84-4.61-2.84-4.35,0-7.12,4.72-7.12,10.76,0,4.14,1.82,6.95,5.36,6.95,1.17,0,2.25-.4,3.25-1.19l1.05-7.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M414.09,170.12h3.11l-3.35,25.2h-3.11l3.35-25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M426.38,174.08h-5.55l.53-3.96h14.2l-.55,3.96h-5.55l-2.8,21.24h-3.11l2.82-21.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.3,189.49h-8.42l-2.42,5.83h-3.32l10.88-25.2h3.08l4.16,25.2h-3.08l-.88-5.83Zm-.57-3.67l-1.7-11.09-4.62,11.09h6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M458.57,170.12h3.11l-2.82,21.24h8.75l-.53,3.96h-11.86l3.35-25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M492.88,182.43h2.94l-1.36,10.15c-1.67,1.98-3.92,3.1-6.24,3.1-5.02,0-8.13-4.36-8.13-10.76,0-8.53,4.09-15.15,10.4-15.15,3.06,0,5.33,1.48,6.72,4.14l-2.25,2.81c-1.1-2.02-2.58-2.84-4.61-2.84-4.35,0-7.12,4.72-7.12,10.76,0,4.14,1.82,6.95,5.36,6.95,1.17,0,2.25-.4,3.25-1.19l1.05-7.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.3,187.33l2.99,7.99h-3.3l-2.75-7.38h-4.16l-.96,7.38h-3.13l3.35-25.2h6.5c4.04,0,6.36,2.81,6.36,7.59s-1.82,8.32-4.9,9.61Zm1.77-9.18c0-2.74-1.29-4.07-3.56-4.07h-3.56l-1.34,10.01h3.71c3.01,0,4.76-2.05,4.76-5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M519.62,184.92c0-8.53,4.09-15.15,10.26-15.15,5.04,0,8.01,4.39,8.01,10.76,0,8.53-4.09,15.15-10.26,15.15-5.04,0-8.01-4.39-8.01-10.76Zm15.14-4.1c0-4.14-1.82-6.95-5.17-6.95-4.21,0-6.84,4.93-6.84,10.76,0,4.14,1.79,6.95,5.14,6.95,4.21,0,6.86-4.93,6.86-10.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M568.48,170.12l-8.87,25.2h-3.32l-1.67-18.47-6.69,18.47h-3.32l-2.2-25.2h3.08l1.65,19.15,6.86-19.15h2.89l1.65,19.33,6.86-19.33h3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M575.8,174.08h-5.55l.53-3.96h14.2l-.55,3.96h-5.55l-2.8,21.24h-3.11l2.82-21.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M603.97,170.12l-3.35,25.2h-3.08l1.41-10.69h-8.66l-1.41,10.69h-3.11l3.35-25.2h3.11l-1.36,10.33h8.66l1.36-10.33h3.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.26,115.8c-.12,48.65-32.77,88.95-79.12,99.19-50.35,11.13-103.38-20.98-116.32-70.93-10.14-39.17,.08-72.83,29.14-100.82,5.61-5.4,14.01-5.42,19.51-.31,5.79,5.39,6.42,13.68,.93,19.69-6.53,7.15-13.12,14.13-17.49,22.97-23.39,47.32,10.86,103.12,63.65,102.85,27.83-.15,49.29-12.94,62.57-37.39,12.95-23.84,11.88-48.11-2.18-71.36-3.52-5.83-8.48-10.84-13.11-15.92-5.68-6.24-6-14.74-.35-20.44,5.6-5.66,14.28-5.4,20.41,.38,17.97,16.94,28.67,37.61,31.88,62.09,.5,3.82,.38,7.72,.48,10.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.71,123.97c-5.75,6.12-10.75,11.22-15.47,16.57-1.98,2.24-3.67,4.85-5.02,7.53-3.42,6.8-2.84,14.99,1.17,19.06,4.2,4.27,9.34,5.77,15.12,4.34,6.46-1.6,9.2-6.67,10.52-12.57,2.73-12.25-5.09-22.42-6.32-34.94Zm-11.87,39.61c-.08,1.13-1.22,2.95-2.11,3.11-2.22,.39-5.33-4.48-5.41-9.03,.39-.37,1.24-1.86,2.28-2,2.3-.33,5.49,4.43,5.24,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.78,78.37c.93,.58,1.23,.88,1.59,.97,5.86,1.53,8.29,5.75,10,11.28,3.43,11.08,7.53,21.95,11.3,32.93,.35,1.03,.33,2.2,.48,3.3,.41-.04,.81-.09,1.22-.13,4.68-9.73,9.36-19.47,14.19-29.52,10.8,5.19,21.25,10.22,31.71,15.25l.34-.7c-10.44-5.02-20.88-10.04-31.67-15.23,.61-1.27,1.04-2.15,1.46-3.04,10.76-22.39,21.37-44.85,32.4-67.11,2.85-5.76,6.71-11.11,10.68-16.2,1.96-2.51,5.23-4,8.15-6.12-2.35-.87-4.86-2.07-7.5-2.72-14.19-3.48-26.54-.06-36.98,10.19-6.32,6.22-10.82,13.68-14.66,21.59-6.01,12.36-11.95,24.76-18.09,37.05-3.33,6.67-6.51,8.37-14.62,8.23Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.96 204 26.98 204.04 27 204 26.96 204"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "266.27 81.17 266.27 97.69 249.71 97.69 249.71 148.38 231.71 148.38 231.71 97.69 215.8 97.69 215.8 81.17 266.27 81.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "397.97 131.88 397.97 148.38 347.97 148.38 347.97 81.17 365.98 81.17 365.98 131.88 397.97 131.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "461.18 131.88 461.18 148.38 411.18 148.38 411.18 81.17 429.19 81.17 429.19 131.88 461.18 131.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "527.38 131.88 527.38 148.38 475.08 148.38 475.08 81.17 526.09 81.17 526.09 97.69 493.08 97.69 493.08 106.44 522.3 106.44 522.3 122.95 493.08 122.95 493.08 131.88 527.38 131.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "320.09 148.38 340.78 148.38 306.08 77.82 271.39 148.38 288.87 148.38 295.49 134 306.1 131.57 298.71 127.01 306.02 111.13 320.09 148.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "589.39 81.17 589.64 116.22 541.63 78.71 541.61 78.71 541.61 97.2 541.61 99.09 541.61 148.38 559.81 148.38 559.57 114.01 607.51 150.79 607.51 81.17 589.39 81.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "581.93 150.93 581.75 150.79 581.75 150.93 581.93 150.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "260.55 139.98 260.56 140.02 260.58 139.98 260.55 139.98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.fac958827c95f1b8f9473ed798cbaca4.svg";
export { ForwardRef as ReactComponent };